import { Group, Text } from '@mantine/core';
import DatasetIcon from '@/components/DatasetIcon.tsx';
import { useHover } from '@mantine/hooks';
import { useViewDataset } from '@/hooks/useViewDataset.ts';
import { Dataset } from '@/types/datasets.ts';

type props = {
  dataset: Dataset;
};

const KnowledgeBaseBadge = ({ dataset }: props) => {
  const { hovered, ref } = useHover();
  const { setDatasetModalId } = useViewDataset();
  return (
    <Group
      ref={ref}
      gap={4}
      wrap="nowrap"
      style={{
        cursor: 'pointer',
        backgroundColor: hovered ? '#ececed' : 'white',
        borderRadius: '4px',
        border: '0.5px solid #ECECED',
        boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.04), 0 3px 6px -2px rgba(0, 0, 0, 0.02)',
      }}
      px={'6px'}
      py={'4px'}
      w={'100%'}
      maw={'fit-content'}
      onClick={() => setDatasetModalId(dataset.id)}
    >
      <DatasetIcon dataset={dataset} size={'14px'} />
      <Text size="11px" truncate={'end'} title={dataset.name} lh={1.2}>
        {dataset.name}
      </Text>
    </Group>
  );
};

export default KnowledgeBaseBadge;
